import React, {useEffect, useRef, useState} from 'react';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../services/TapIcon';
import Loader from '../../components/ui/Loader/Loader';
import { Modal } from "bootstrap";
import { Link } from 'react-router-dom';
import uuid from "react-uuid";
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

function CategoryComponent({type}) {

    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();
    const access_token              =   useSelector(state => state.auth.access_token); 
    const categoryUrl               =   ORG_API_BASE_URL_2 + '/category';

    const initialData               =   {
        name                            :   '',
        type
    };

    const [formData, setFormData]   =   useState({
        submittingForm  :   false,
        editId          :   '',
        submitData      :   initialData
    });

    const [categoryData, setCategoryData]   =   useState({
        loading     :   false,
        data        :   []    
    });

    useEffect(() => {
        modalElementRef.current            =   document.getElementById(modalId);
        modalRef.current                    =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});
        getCategories();

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);
    
    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        setFormData(pre => ({...pre, editId: '', submitData: initialData}))
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }

    const getCategories             =   () => {
        setCategoryData(pre => ({...pre, loading: true}));

        HttpAPICall.withAthorization("GET", `${categoryUrl}/list`, access_token, {type}, {}, (response) => {
            setCategoryData(pre => ({...pre, data: response.data}));
        }).then(() => setCategoryData(pre => ({...pre, loading: false})));

    }

    
    const submitForm                =   (e) => {
        e.preventDefault();
        setFormData(pre => ({...pre, submittingForm: true}));
        let method      =   'POST';
        let url         =   `${categoryUrl}/add`;
        let params      =   {...formData.submitData, type};
        if(formData.editId) {
            method          =   "PUT";
            url             =   `${categoryUrl}/edit`;
            params          =   {...params, id : formData.editId}
        }
        HttpAPICall.withAthorization(method, url, access_token, {}, params, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            closeModal();
            getCategories();
        }).then(() => setFormData(pre => ({...pre, submittingForm: false})));
        
    }
    const handleEdit                =   (id) => {
        const editData              =   categoryData.data.find(d => d.id === id);
        setFormData(pre => ({...pre, editId: id, submitData: {name: editData.name}}));
        openModal();
    } 

    const deleteCat                 = (id) => {
        let category                     =   categoryData.data.find(c => c.id === id);
        if(category) {
            swal({
                title: "DELETE",
                text: "This action cannot be reversed, Are you sure you want to proceed?",
                icon: "warning",
                dangerMode: true,
                buttons: ["No", "Yes"],
            }).then(willDelete => {
                if (willDelete) {
                    HttpAPICall.withAthorization('DELETE', `${categoryUrl}/delete/${id}`, access_token, {}, {}, (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        getCategories();
                    }).then(() => {});
                }
            });
        }
    }


    const modalJsx                  =   () => {

        const {submittingForm, editId}    =   formData;

        return <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{editId ? "Edit" : "Add"} Category</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={submittingForm} onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={submitForm} id={modalId+"Form"} method="post">
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label require">Category Name</label>
                                </div>
                                <div className="col-sm-6">
                                    <input
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFormData(pre => ({...pre, submitData: {...formData.submitData, name: e.target.value}}))
                                        }}
                                        value={formData.submitData.name}
                                        autoComplete="off"
                                        required={true}
                                        placeholder={`Please Enter Category Name`}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={submittingForm} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        <button type="submit" form={modalId+"Form"} disabled={submittingForm} className="btn btn-primary">Save {submittingForm && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    }

  return (
    <>
        <div className="tab_content_wrapper my-2">
            <span className="content_heading">Categories</span>
            <button className="btn btn-primary" onClick={openModal}>Add</button>
        </div>
        <table className="table table-hover table-bordered my-3 table-sm ">
            <thead className="table-secondary">
                <tr>
                    <th scope="col" style={{ width: "10%" }} className="text-center">S.No</th>
                    <th scope="col" className="text-start">Name</th>
                    <th scope="col" style={{ width: "10%" }} className="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                {
                    categoryData.loading 
                    ? <tr className='text-center'><td colSpan={3}><Loader/></td></tr>
                    : categoryData.data.length > 0 
                    ? categoryData.data.map((cate, i) => (
                        <tr key={cate.id}>
                            <td className='text-center'>{i+1}</td>
                            <td>{cate.name}</td>
                            <td className='text-center'>
                                <button type="button" className="btn btn-link" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                    <TapIcon.imageIcon icon={TapIcon.ListActionIcon} className="img-fluid" alt="action-icon" />
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link role="button" className='dropdown-item cursor_pointer' style={{ "pointerEvents": "all" }} onClick={() => handleEdit(cate.id)}>Edit</Link>
                                        <Link role="button" className='dropdown-item cursor_pointer' style={{ "pointerEvents": "all" }} onClick={() => deleteCat(cate.id)}>Delete</Link>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    ))
                    : <tr className='text-center'><td colSpan={3}>No Record</td></tr>
                }
            </tbody>
        </table>
        {modalJsx()}
    </>
  )
}

export default CategoryComponent;